import Order from '../models/orderModel';

export default class OrderAction {
    static CAPACITIES = ['PyvarCapacity.ADMIN', 'PyvarCapacity.ORDER'];
    static NAME = 'abstract';
    static TYPE = 'orders';
    static POST_ACTION_COMPONENT = null;
    static POST_ACTION_TOAST = () => null;
    static ASYNCHRONOUS_LIMIT_MIN = Infinity;

    constructor({ items, sync, onClose, organization, event }) {
        this.items = items;
        this.filtered_items = items;
        this.sync = sync;
        this.onClose = onClose;
        this.organization = organization;
        this.event = event;
        this.async = false;
    }

    static condition(order) {
        return true;
    }

    static payment_plan_condition(order) {
        // restrict actions if order is from a payment plan
        return !(order.is_payment_plan && order['status'] !== 'valid');
    }

    static is_available({ event, feature_flags, items }) {
        return true;
    }

    static is_disabled({ items }) {
        return !items.some(i => this.condition(i));
    }

    static is_attendee_valid() {
        return true;
    }

    get is_direct() {
        return false;
    }

    // global
    get needs_confirm() {
        return Array.isArray(this.items) && this.items.length > 1;
    }

    get warning_confirm() {
        return false;
    }

    // simple
    get needs_selection() {
        return (Array.isArray(this.items) && this.items.length === 1) || !Array.isArray(this.items);
    }

    isAsync(items = null) {
        let _items = items || this.filtered_items;
        if (Array.isArray(_items) && _items.length >= this.constructor.ASYNCHRONOUS_LIMIT_MIN) {
            this.async = true;
        } else {
            this.async = false;
        }
        return this.async;
    }

    filter() {
        this.filtered_items = this.items.filter(i => this.constructor.condition(i));
    }

    run() {
        return Order.perform_action(this.constructor.NAME, this.filtered_items, { organization: this.organization, event: this.event }, this.isAsync());
    }

    onActionDone() {
        this.onClose();
    }

    get post_action() {
        return false;
    }

    get withToastRun() {
        return true;
    }

    runPostAction() {}
}
